import { render } from "./ExerciseScoring.vue?vue&type=template&id=51d6d602"
import script from "./ExerciseScoring.vue?vue&type=script&lang=js"
export * from "./ExerciseScoring.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__